import * as React from 'react';
import VolmaInput from '../../VolmaInput';
import { injectable } from 'inversify';
import PropertyHelper from '../../../Infrastructure/Services/PropertyHelper';
import { Types } from '../../../Infrastructure/Types';
import { VolmaContainer } from '../../../Infrastructure/InversifyInject';
import { BaseValidator } from '../../../Infrastructure/Validation/BaseValidator';
import { IVolmaInputProps } from '../../VolmaInput/IVolmaInputProps';
import { IBaseEntityProps } from '../BaseEntity/IBaseEntityProps';
import { VolmaTableService } from '../../../Infrastructure/Services/VomaTableService';
import { VolmaInputValidator } from '../../../Infrastructure/Validation/VolmaInputValidatorValidator';
import { IVolmaTableColumn } from '../../Table/VolmaTable/IVolmaTableProps';
import { EEntityType } from '../../../Domain/Enum/EEntityType';
import VolmaSelect from '../../VolmaSelect';
import { HandlingTypeTableDTO } from '../../../Domain/DTO/HandlingTypeTableDTO';
import { HandlingTypeDTO } from '../../../Domain/DTO/HandlingTypeDTO';
import { BaseEntityService } from '../BaseEntity/BaseEntityService';
import { EUserRole } from '../../../Domain/Enum/EUserRole';
import { VolmaTableHeaderRenderers } from '../../Table/VolmaTable/Renderers/VolmaTableHeaderRenderers';
import i18next from '../../i18n';
import { ConsigneeDTO } from '../../../Domain/DTO/ConsigneeDTO';

@injectable()
export class ConsigneeEntityService extends BaseEntityService<ConsigneeDTO, any>{
    private _inputValidator: BaseValidator<IVolmaInputProps>;
    private _volmaTableService: VolmaTableService;

    constructor() {
        super();

        this._volmaTableService = VolmaContainer.get<VolmaTableService>(Types.VolmaTableService);
        this._inputValidator = VolmaContainer.get<VolmaInputValidator>(Types.VolmaInputValidator);
    }

    public GetTableSubsidiaryEntities(): Array<EEntityType> {
        return [EEntityType.Consignee]
    }

    public GetColumnsList(): Array<IVolmaTableColumn> {
        return this._volmaTableService.GetColumnsByKeys(
            EEntityType.Consignee,
            [
                { DataKey: PropertyHelper.GetPropertyName((val: ConsigneeDTO) => val.Id) },
                { DataKey: PropertyHelper.GetPropertyName((val: ConsigneeDTO) => val.Name), HeaderRenderer: VolmaTableHeaderRenderers.TextHeaderRenderer }
            ]
        );
    }

    public GetEntityId(props: IBaseEntityProps<ConsigneeDTO, {}>): any {
        return super.GetAlternateEntityId(
            props.match.params.id,
            PropertyHelper.GetPropertyName((x: ConsigneeDTO) => x.Id),
            (x: HandlingTypeTableDTO, id: string) => x.Code.toLowerCase() === id);
    }

    public GetEditorModal(props: IBaseEntityProps<HandlingTypeDTO, any>): JSX.Element {
        return undefined;
    }

    public GetEditor(props: IBaseEntityProps<HandlingTypeDTO, any>): JSX.Element {
        return this.GetEditorModal(props);
    }

    public GetHeaderEditor(props: IBaseEntityProps<HandlingTypeDTO, any>): JSX.Element {
        let isEditable = this.IsEditable(props);
        return (
            <div>
                <div className={(this._createCard("cell")).toString()}>
                    <VolmaInput
                        {...PropertyHelper.GetInputPropertyByName(props.Inputs, (val: ConsigneeDTO) => val.Name) }
                        Name={PropertyHelper.GetPropertyName((val: ConsigneeDTO) => val.Name)}
                        Label={i18next.t('handlingtype:Code')}
                        Placeholder={i18next.t('handlingtype:CodePlaceholder')}
                        Value={props.DataDTO.Code}
                        Validator={this._inputValidator}
                        IsInHeader={true}
                        Required={true}
                        Readonly={!isEditable}
                        dispatch={props.dispatch} />
                </div>
            </div>
        );
    }

    public InitializeEntity(props: IBaseEntityProps<HandlingTypeDTO, any>) {
    }

    public GetReducer() {
        return undefined;
    }

    public OnAfterDataLoaded(dto: HandlingTypeDTO): void {
    }

    public GetInitialDataHelper() {
        return {};
    }

}